<template>
    <div>
        <boton-atras  v-if="!vistaSeteoPass" :nombre_ruta="'modulo-planeacion'"></boton-atras>
        <div id="mySidenav" class="sidenav">
            <a href="javascript:void(0)" class="d-flex justify-content-between align-items-center closebtn py-0 px-4 m-0 bg-light w-100" style="margin-right:-1rem;" @click="closeNav()">
                <span class="m-0 p-0" style="font-size:1rem;">¿No puedes acceder a tu cuenta?</span> &times;
            </a>
            <a @click="verSetearPassword(), closeNav()" type="button">¿Olvidó su usuario y/o contraseña?</a>
            <a @click="registrarse(), closeNav()" type="button">Registrarse</a>
            <a type="button" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                Tengo un problema con mi correo
            </a>
            <div class="collapse mt-0" id="collapseExample">
                <div class="card-body mt-0">
                   <span class="bold500 w-100 text-center">Contacto</span>
                   <p class="m-0 p-0">
                       Número de contacto: 961-691-4043, a las extensiones 65532 y 65300.
                        Oficinas: Área de Sistemas de Calidad de la Unidad de Planeación, ubicada en el Edificio Torre Chiapas, 4º piso, Col. El Retiro, Tuxtla Gutiérrez, Chiapas
                        Email: control.formatos@{{ urlSubdominio }}
                    </p>

                </div>
            </div>
        </div>


        <!-- login -->
        <div v-if="!vistaSeteoPass" class="container mt-2" > <!---style="margin-top:1rem; margin-bottom:5rem; height:60vh;"-->
            <div id="formulario-login" v-scroll-reveal>
                <div class="container">
                    <div class="row">
                        <div class="d-none d-sm-none d-md-block col-md-5 tramite">
                            <img class="d-none d-md-block w-100" src="@/assets/imagenes/login_img.svg" alt="">
                        </div>
                        <div class="col-md-7 login pt-5">
                                <div class="mb-2 text-right">
                                    <!-- <img src="" class="img"> -->
                                </div>
                                <!-- <h6 class="mt-3 text-center text-muted">Administrador de formatos</h6> -->
                                <h5 class="bold mb-4 text-center" :class="modoDark_var? 'text-white' : ''">Bienvenido</h5>
                                <form v-on:submit.prevent="login" ref="formLogin">
                                    <!-- <div class="alert alert-primary mb-1 py-2 alert-dismissible fade show" role="alert">
                                      <i class="fas fa-info-circle mr-2"></i>  Estimado usuario, a partir del 00/00/2022 el ingreso a esta aplicación será a través de su correo electrónico.
                                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div> -->
                                    <div class="form-group">
                                        <!-- <label for="usuario">Usuario</label> -->
                                        <input type="text" v-model.trim="usuario" class="form-control form-control-lg" id="usuario" placeholder="Usuario" style="font-size:1rem;">
                                    </div>
                                    <div class="form-group mb-0">
                                        <!-- <label for="password">Contraseña</label> -->
                                        <input type="password" v-model.trim="pass" class="form-control form-control-lg" id="password" placeholder="Contraseña" style="font-size:1rem;">
                                    </div>
                                    <div class="mb-3 text-right">

                                        <a type="button" style="color:grey; font-size:.9rem;" @click="openNav()">¿No puedes acceder a tu cuenta?</a>
                                        <!-- <button type="button" @click="verSetearPassword()" class="btn btn-link text-dark boldbold500 p-0 txt-resetPass">¿No puedes acceder a tu cuenta?</button> -->
                                    </div>
                                    <p v-if="errores" class="small text-danger my-0"> {{errores==1? '*Debe llenar los campos, son obligatorios.' : '*Usuario o contraseña erronea'}} </p>
                                    <div class="mt-5 mb-0">
                                        <button type="submit" class="btn btn-vino py-2 px-5 btn-block">Iniciar sesión</button>
                                    </div>
                                    <hr>
                                    <!-- <div class=" mb-0 text-center">
                                        <button type="button" @click="registrarse()" style="text-decoration-line: underline;" class="btn btn-link text-dark p-0">Registrarse</button>
                                    </div> -->
                                </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- seteo password -->
        <div v-if="vistaSeteoPass">
            <seteo-pass
            @ver_login="ver_login=$event"
            >
            </seteo-pass>
        </div>
        <div v-if="maxHeight" style="padding-bottom:16%;"></div>

        <!-- Mensaje antes de redirrecionar al REGISTER del SSO -->
        <div class="modal fade" id="msj_sso" tabindex="-1" role="dialog" aria-labelledby="miModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <!-- Header -->
                    <div class="modal-header">
                        <h5 class="modal-title" id="miModalLabel"><i class="fas fa-exclamation-triangle"></i> ¡Aviso Importante!</h5>
                    </div>
                    <!-- Body -->
                    <div class="modal-body">
                       <!--  <p>El registro de usuarios ahora se realizará a traves de la plataforma <span class="llave_chiapas font-weight-bold">Llave Chiapas</span></p>
                        <p>Para poder acceder a los formatos deberá ingresar a la plataforma:  <a class="font-weight-bold" href="https://servicios.finanzaschiapas.gob.mx/miOficina/auth/login" target="_blank">Mi oficina Chiapas</a>  <i class="far fa-hand-pointer"></i></p>
                        <p>Si ya cuenta con un usuario y contraseña registrados en el sistema anterior, no es necesario realizar un nuevo registro. Por el momento, podrá continuar utilizando sus credenciales actuales para acceder a los formatos desde la plataforma anterior.</p>-->

                        <p>El registro de usuarios ahora se realizará en una nueva plataforma.</p>
                        <p>Para poder acceder a los formatos deberá ingresar al siguiente enlace:  <a class="font-weight-bold" href="https://servicios.finanzaschiapas.gob.mx/miOficina/auth/login" target="_blank">https://servicios.finanzaschiapas.gob.mx/miOficina/auth/login</a>  <i class="far fa-hand-pointer"></i></p>
                        <p>Si ya cuenta con un usuario y contraseña registrados en el sistema anterior, no es necesario realizar un nuevo registro. Por el momento, podrá continuar utilizando sus credenciales actuales para acceder a los formatos desde la plataforma anterior.</p>
                    </div>
                    <!-- Footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"> Cerrar </button>
                        <a class="btn btn-navigate" href="https://servicios.finanzaschiapas.gob.mx/registroID/register"> Ir al nuevo registro </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import botonAtras from '../../button-atras.vue'
import seteoPass from './seteoPassword.vue'
import AutorizacionTramiteshacienda from "./../../../services/autorizacionTramites";
import { mapState } from "vuex";
const _servicesAuth = new AutorizacionTramiteshacienda();
export default({
    name: 'login-vista',
    components:{
        seteoPass,
        botonAtras
    },
    data: function() {
        return{
            usuario: '',
            pass: '',
            errores: 0,
            datosUsuarioLog: {},
            vistaSeteoPass: false,

            ver_login: false, ///$emit
            show_msj_sso: false

        }
    },
    methods:{
        openNav() { document.getElementById("mySidenav").style.width = "350px"; },
        closeNav() { document.getElementById("mySidenav").style.width = "0"; },

        registrarse(){
            //console.log('asdasd register');
            this.$emit('register', true);

            //⚠️ DESCOMENTAR CUANDO SE HABILITE EL REGISTRO DE USUARIOS CON SSO // 
            // $('#msj_sso').modal('show');
        },
        login: async function(){
            //errores = 1 campos vacios, 2 campos erroneos
            if(this.usuario == '' || this.pass == ''){
                this.errores = 1;
                return
            }

            let result = null;
            result = await _servicesAuth.LoginUser(this.usuario, this.pass);

            // si la peticion es exitosa...
            if(result.success){
                // result.data.idestatus == 0 usuario no autenticado, emite evento
                //this.getIdUsuario(result.data.idUsuario); // <-- guardo en vuex el id del usuario para compartirlo de forma segura
                if(result.data.idestatus == 0){
                    this.datosUsuarioLog = {
                        idusuario: result.data.idUsuario,
                        email: result.data.correo_electronico,
                        noAutenticado: true
                    }
                    this.$emit('userNoAutenticado', this.datosUsuarioLog);
                }else{
                    _servicesAuth.setDatosCookie(result.data.idUsuario, result.data.nombre_pantalla, result.data.token);
                    this.$router.push({name: 'TramitesHacienda'});
                }
            }else if(result.error == 400) this.errores = 2;

            //console.log(result);
        },
        verSetearPassword(){
            //console.log("aqui ira el seteo del password");
            this.vistaSeteoPass = true;
            this.ver_login = false;
        },
    },
    created(){
    },
    watch:{
        ver_login: function(){
            if(this.ver_login){
                this.vistaSeteoPass = false;
           }
        }
    },
    computed:{
        maxHeight(){ return window.screen.height>800? true : false },
        ...mapState(['modoDark_var'])
    },
    mounted(){
        window.scrollTo(0, 0);
    },
})
</script>
<style scoped>
    #formulario-login .container{
        max-width: 1000px !important;
        /* box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important; */
    }
    #formulario-login .img{width:25%;}
    label, .text-confirmacion{
        color: #777272 !important;
        margin-bottom: 0 !important;
    }
    #formulario-login .tramite{
        width: 30%;
        /* background-color: #f7f7f7; */
        display: flex !important;
        align-items: center !important;
        /* background-image: url(img.jpg); */
    }
    #formulario-login .login{
        padding: .5rem 2rem 2rem 2rem;

    }
    #formulario-login label{ font-size: .8rem; color: #b2afaf; }
    #formulario-login h5{
        font-size: 1.7rem;
        font-weight: 400;
        color: #625151;
    }
    #formulario-login  button { font-weight:500;}
    #formulario-login .txt-resetPass{
        font-size: 12.5px;
        margin-top: .5rem;
        font-weight: 500;
        /* color: #5897fb; */
    }
    /****** */
    .formulario-registro{
        /**max-width: 1000px !important;**/
        margin-top: 3rem;
        margin-bottom: 5rem;
        border: 2px solid #efefef;
        padding: 2rem 3rem 3rem 3rem;
        border-left: 5px solid #7f2535;
    }
    /* ________________ */





.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3000;
  top: 0;
  right: 0;
  background-color: #fff;
    border-left:4px solid grey;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
}

.sidenav a {
  padding: 1rem;
  text-decoration: none;
  font-size: 1.1rem;
  color: #686868;
  display: block;
  transition: 0.3s;
}

.sidenav a:hover {
  color: /*#f1f1f1;*/  #691c32;/* #9f2241;*/
}

.sidenav .closebtn {
  position: absolute;
  top: 0;
  /* right: 25px; */
  font-size: 36px;
  /* margin-left: 50px; */
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
#msj_sso .modal-content{
    border-radius: 10px;
}
#msj_sso .modal-header{
    background-color: #009886;
    color: #fcfcfcd9 !important
}
#msj_sso .modal-body p{
    font-size: .95rem;
    color: #625151
}
#msj_sso .modal-body .llave_chiapas{
    color: #009886
}
#msj_sso .modal-body a{
    font-size: .95rem;
    color: #d5006a;
    text-decoration: underline;
}
#msj_sso .modal-footer .btn-navigate{
    background-color: #d5006a;
    color: #fcfcfcd9 !important;
}
</style>
